import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

const useStyles = makeStyles(
	{
		root: {
			width: 600,
			height: '100%',
			padding: '24px 20px 20px 20px'
		},
		primartyText: {
			color: '#FFFFFF',
			fontFamily: 'Graphik',
			fontSize: 14,
			fontWeight: 600,
			letterSpacing: 0,
		},
		solidDot: {
			backgroundColor: "#F9A51A",
			borderColor: "#F9A51A"
		},
		emptyDot: {
			borderColor: "#F9A51A"
		},
		secondaryText: {
			height: 16,
			color: '#003B62',
			fontFamily: 'Graphik',
			fontSize: 16,
			fontWeight: 700,
			letterSpacing: 0,
			textAlign: 'center'
		},
		paper: {
			height: 48,
			borderRadius: 6,
			backgroundColor: '#005383',
			textAlign: 'center',
			paddingTop: 14
		  },
		  connector: {
			backgroundColor: '#E0E0E0'
		  }
	}
);

function createTimelineItem(item, index, classes) {
	return (
		<TimelineItem key={"timeline"+index}>
			<TimelineOppositeContent>
				<span className={classes.secondaryText}>{item.secondary}</span>
			</TimelineOppositeContent>
			<TimelineSeparator>
				<TimelineDot
				className={((index === 0) ? classes.solidDot : classes.emptyDot)}
				variant={((index === 0) ? 'default' : 'outlined')}
			/>
				<TimelineConnector className={classes.connector}/>
			</TimelineSeparator>
			<TimelineContent style={{position: "relative", top: "-2vh"}}>
				<Paper className={classes.paper}>
					<span className={classes.primartyText}>{item.primary}</span>
				</Paper>
			</TimelineContent>
		</TimelineItem>
	);
}

const VerticalTimeLineCard = ( {items} ) => {
	const classes = useStyles();

	return (
		<Card elevation={0} className={classes.root}>
			<CardContent>
				<Timeline align="alternate">
					{items.map((item, index) => createTimelineItem(item, index, classes))}
				</Timeline>
        	</CardContent>
		</Card>
	)
}

export default VerticalTimeLineCard;